import React, { Component } from 'react';

import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Colors, withTheme, getThemeImages, LightThemeColors } from '../Themes';
import VFInput from '../VFInput';

const passwordShowHideIconsName = Object.freeze({
  showPassword: 'ic_show_password_insights',
  hidePassword: 'ic_hide_password',
});

class PasswordInput extends Component {
  constructor(props) {
    super(props);

    const rightIcon = passwordShowHideIconsName.showPassword;
    const shouldHidePassword = true;
    const showPasswordIcon = true;

    this.state = {
      rightIcon,
      shouldHidePassword,
      showPasswordIcon,
    };
  }

  onRightIconPress = () => {
    const { shouldHidePassword, rightIcon } = this.state;
    const newRightIcon =
      rightIcon === passwordShowHideIconsName.showPassword
        ? passwordShowHideIconsName.hidePassword
        : passwordShowHideIconsName.showPassword;
    this.setState({
      shouldHidePassword: !shouldHidePassword,
      rightIcon: newRightIcon,
    });
  };

  handleOnChange = text => {
    const { onChangeText } = this.props;

    if (_isFunction(onChangeText)) {
      onChangeText(text);
    }
  };

  render() {
    const { rightIcon, shouldHidePassword, showPasswordIcon } = this.state;
    const { theme } = this.props;
    const images = getThemeImages(theme.name);

    return (
      <VFInput
        leftIconName={images.ic_password_key}
        secureTextEntry={shouldHidePassword}
        rightIconName={images[rightIcon]}
        showRightIcon={showPasswordIcon}
        rightIconPress={() => this.onRightIconPress(theme)}
        {...this.props}
        onChangeText={this.handleOnChange}
        testID={FoundationTestKeys.passInputVFInputTestKey}
      />
    );
  }
}

PasswordInput.defaultProps = {
  label: 'Password',
  baseColor: Colors.light_grey,
  tintColor: Colors.light_grey,
  textColor: Colors.dark_grey,
  theme: LightThemeColors,
};

PasswordInput.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  baseColor: PropTypes.string,
  tintColor: PropTypes.string,
  textColor: PropTypes.string,
  onChangeText: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(PasswordInput);
